import 'ol/ol.css';
import { Vector as VectorLayer, Heatmap } from 'ol/layer'
import { Vector as VectorSource } from 'ol/source'
import { Style, Stroke, Fill, Text, RegularShape } from 'ol/style.js';
import GeoJSON from "ol/format/GeoJSON";
import Point from "ol/geom/Point";
import { getSourceForGeoJSON, setMapSingleEventHandler } from 'map/OlExtension'
import { getVectorContext } from 'ol/render';
import { unByKey } from 'ol/Observable';
import { getRandomIntInclusive } from 'utils/commonFunc';
import { Circle as CircleStyle } from 'ol/style';
import { orange, red, yellow } from '@mui/material/colors';

export default class CommonHeatmapLayer extends Heatmap { 
    constructor(options, data) {
        super({
            name: 'heatmapLayer',
            source: data ? getSourceForGeoJSON(data) : new VectorSource(),
            opacity: 1,
            blur: 2,
            radius: 4,
            weight:(feature) => this.weightFunction(feature),
            ...options
        });
    }

    weightFunction = function (feature) {        
        return feature.get("properties")?.heatmapValue
    };

    update = (propertyName, maxValue) => {
        this.getSource()?.forEachFeature(feature => {
            const value = feature.get(propertyName)
            feature.set("properties", {heatmapValue:value / maxValue})
        });
    }

    updateForEach = (heatmapValueCallback) => {
        this.getSource()?.forEachFeature(feature => {
            feature.set("properties", {heatmapValue:heatmapValueCallback(feature)})
        });
    }

    clear = (featrues) => {
        const source = this.getSource()
        source.clear()
    }

    add = (featrues) => {
        const source = this.getSource()
        source.clear()
        source.addFeatures(featrues)
    }
}